// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3g119","container":"styles_container__10CeI","title":"styles_title__G1aUR","wrapper":"styles_wrapper__zAoJ5","answer":"styles_answer__3g-H6"};